import React from 'react';
import {
  Alert, Box, Button, Divider, FormControlLabel, Switch, Typography,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { useWorkspace } from '../WorkspaceContext.js';
import { ACTION_META, ACTION_TYPES } from '../workspaceConstants.js';

const LAYER_ROWS = [
  { key: 'buildings', label: 'Gebäude' },
  { key: 'waterLevel', label: 'Wasserstand' },
  { key: 'discharge', label: 'Abfluss' },
  { key: 'flowPathsStatic', label: 'Fließwege statisch' },
  { key: 'flowPathsAnimated', label: 'Fließwege animiert' },
];

const ViewPanel = () => {
  const { layers, setLayer, setActionTypeLayer, activeScenario, exportPdf, exporting } = useWorkspace();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {!activeScenario && (
        <Alert severity="info" sx={{ mb: 1 }}>
          Die Ergebnis- und Maßnahmenebenen werden erst angezeigt, wenn im Menü „Szenarios" ein
          Szenario aktiviert ist.
        </Alert>
      )}

      {LAYER_ROWS.map(({ key, label }) => {
        // Without an active scenario the buildings are always shown, so their
        // toggle is locked on.
        const locked = key === 'buildings' && !activeScenario;
        return (
          <FormControlLabel
            key={key}
            control={
              <Switch
                checked={locked || layers[key]}
                disabled={locked}
                onChange={(e) => setLayer(key, e.target.checked)}
              />
            }
            label={label}
          />
        );
      })}

      <Divider sx={{ my: 1 }} />

      <FormControlLabel
        control={<Switch checked={layers.actions} onChange={(e) => setLayer('actions', e.target.checked)} />}
        label="Maßnahmen"
      />
      <Box sx={{ pl: 3, display: 'flex', flexDirection: 'column' }}>
        {ACTION_TYPES.map((type) => (
          <FormControlLabel
            key={type}
            control={
              <Switch
                size="small"
                checked={layers.actionTypes[type]}
                disabled={!layers.actions}
                onChange={(e) => setActionTypeLayer(type, e.target.checked)}
              />
            }
            label={
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{
                  width: 14, height: 14, borderRadius: '3px', flexShrink: 0,
                  backgroundColor: ACTION_META[type].color, border: '1px solid #666',
                }} />
                <Typography variant="body2">{ACTION_META[type].label}</Typography>
              </Box>
            }
          />
        ))}
      </Box>

      <Divider sx={{ my: 1 }} />

      <Button
        variant="contained"
        startIcon={<DownloadIcon />}
        onClick={exportPdf}
        disabled={!activeScenario || activeScenario.status !== 'done' || exporting}
      >
        Als PDF exportieren
      </Button>
      <Typography variant="caption" color="text.secondary">
        Exportiert die aktuell gewählten Ergebnisebenen des aktiven Szenarios als Standbild.
      </Typography>
    </Box>
  );
};

export default ViewPanel;
